export const ENDPOINTS = {
  translations: 'translations',
  checkAccess: 'translations/check-access',
  update: 'translations/upsert',
};
